import initialState from '../initialState';
import * as types from './actionTypes.microphone';

let initialStateObj = {
    isActive: initialState.microphone.isActive
};

export default function MicrophoneReducer(state = initialStateObj, action) {
    switch (action.type) {

        default:
            return state;
    }
}